import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ContextualHelpService from '../services/ContextualHelpService';

const ContextualHelpContext = createContext(null);

export const ContextualHelpProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const [topic, setTopic] = useState(null);
  const [anchor, setAnchor] = useState(null);
  const [content, setContent] = useState(null);

  const closeHelp = useCallback(() => {
    setIsOpen(false);
  }, []);

  const openHelp = useCallback(async ({ module: moduleArg, topic: topicArg, anchor: anchorArg } = {}) => {
    if (!moduleArg || !topicArg) {
      console.error('useContextualHelp().openHelp: module y topic son requeridos', { moduleArg, topicArg });
      return;
    }
    setModuleName(moduleArg);
    setTopic(topicArg);
    setAnchor(anchorArg || null);
    setIsOpen(true);
    setIsLoading(true);
    setError(null);
    try {
      const data = await ContextualHelpService.getTopic(moduleArg, topicArg);
      setContent(data?.content || '');
    } catch (err) {
      console.error('ContextualHelpProvider.openHelp: no se pudo obtener el contenido de ayuda', err);
      setContent(null);
      setError(err?.message || 'No se pudo cargar la ayuda.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const value = useMemo(
    () => ({ isOpen, isLoading, error, module: moduleName, topic, anchor, content, openHelp, closeHelp }),
    [isOpen, isLoading, error, moduleName, topic, anchor, content, openHelp, closeHelp]
  );

  return <ContextualHelpContext.Provider value={value}>{children}</ContextualHelpContext.Provider>;
};

export const useContextualHelp = () => {
  const ctx = useContext(ContextualHelpContext);
  if (!ctx) {
    throw new Error('useContextualHelp debe usarse dentro de un ContextualHelpProvider');
  }
  return ctx;
};

export default ContextualHelpContext;
